/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import axios from "axios";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import swal from "sweetalert";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { API_HOHOLOK } from "utils";

// Data dummy untuk reports line chart
const reportsLineChartData = {
  sales: {
    labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: {
      label: "Mobile apps",
      data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
    },
  },
};

// Fungsi format rupiah
function formatRupiah(angka) {
  if (!angka && angka !== 0) return "";

  // Konversi ke number untuk memastikan tipe data yang benar
  const numAngka = Number(angka);
  if (isNaN(numAngka)) return "";

  // Format angka dengan pemisah ribuan dan 2 desimal
  const formatted = numAngka.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return "Rp " + formatted;
}

function extractProgresValue(val) {
  if (!val) return 0;
  if (typeof val === "string") {
    return parseFloat(val.replace("%", "")) || 0;
  }
  if (typeof val === "number") {
    return val;
  }
  if (val.props && typeof val.props.children === "string") {
    return parseFloat(val.props.children.replace("%", "")) || 0;
  }
  if (val.props && typeof val.props.children === "number") {
    return val.props.children;
  }
  return 0;
}

// Helper untuk mengambil data total progres per minggu dari baris total
function getTotalProgresPerMinggu(tableRows, tableColumns) {
  if (!tableRows || tableRows.length === 0) return [];
  const totalRow = tableRows[tableRows.length - 1];

  return tableColumns
    .filter((col) => col.accessor && col.accessor.startsWith("minggu_"))
    .map((col) => extractProgresValue(totalRow[col.accessor]));
}

function Kurva_S() {
  const { sales } = reportsLineChartData;
  const [proyekList, setProyekList] = useState([]);
  const [selectedProyek, setSelectedProyek] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openKurvaS, setOpenKurvaS] = useState(false);
  const [kurvaSForm, setKurvaSForm] = useState([
    { minggu_ke: "", progres_rencana: "" },
  ]);
  const [kurvaSLoading, setKurvaSLoading] = useState(false);
  const [selectedUtama, setSelectedUtama] = useState(null);
  const [isEditKurvaS, setIsEditKurvaS] = useState(false);
  const [dataKurvaSPerUtama, setDataKurvaSPerUtama] = useState([]);
  const [dataGrap, setDataGrap] = useState({ labels: [], datasets: {} });
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [id_perusahaan, setIdPerusahaan] = useState(null);
  const [status, setStatus] = useState(null);
  const currentProyekRef = useRef(null);
  const abortControllerRef = useRef(null);

  // List satuan umum konstruksi

  const [tableRows, setTableRows] = useState([]);
  // Ambil semua minggu unik dari dataKurvaSPerUtama
  const mingguList = [
    ...new Set(dataKurvaSPerUtama.map((k) => k.minggu_ke)),
  ].sort((a, b) => a - b);

  // Kolom statis
  const staticColumns = [
    { Header: "Uraian Pekerjaan", accessor: "uraian_pekerjaan", width: "30%" },
    { Header: "Total Harga", accessor: "total_harga", width: "15%" },
    { Header: "Bobot (%)", accessor: "bobot", width: "10%" },
    // Kolom minggu akan ditambahkan di bawah
  ];

  useEffect(() => {
    const userStorage = localStorage.getItem("user");
    if (userStorage) {
      const user = JSON.parse(localStorage.getItem("user"));
      const statusKU = user.status;
      if (statusKU == "user") {
        setIdPerusahaan(user.id_perusahaan);
      }
      setStatus(statusKU);
    }
  }, []);

  const [tableColumns, setTableColumns] = useState([...staticColumns]);

  useEffect(() => {
    if (tahun) {
      fetchProyek();
    }
  }, [tahun]);

  const fetchProyek = () => {
    setLoading(true);
    const url =
      status == "user"
        ? `${API_HOHOLOK}proyek/perusahaan/${id_perusahaan}/tahun/${tahun}`
        : `${API_HOHOLOK}proyek/tahun/${tahun}`;
    axios
      .get(url)
      .then((res) => {
        const data = res.data || [];
        const dataKU = data.map((item) => ({
          label: item.nama_proyek,
          value: item.id_proyek,
          ...item,
        }));
        setProyekList(dataKU);
        setSelectedProyek(dataKU[0]);
        setLoading(false);
      })
      .catch(() => {
        setProyekList([]);
        setLoading(false);
      });
  };

  // Fungsi untuk fetch data proyek + pekerjaan utama + sub + kurva_s
  const fetchProyekKurvas = (idProyek) => {
    axios
      .get(`${API_HOHOLOK}proyek/kurvas/${idProyek}`)
      .then((res) => {
        const data = res.data || {};
        const pekerjaanUtama = data.pekerjaan_utama || [];
        const kurvaS = data.kurva_s || [];
        // Simpan data kurva_s ke state untuk akses saat buka modal
        setDataKurvaSPerUtama(kurvaS);
        // Hitung total harga semua sub pekerjaan untuk bobot global
        let allSubs = pekerjaanUtama.flatMap((utama) =>
          (utama.sub_pekerjaan || []).map((sub) => {
            const hargaSatuan = Number(sub.harga_satuan) || 0;
            const volume = Number(sub.volume) || 0;
            const totalHarga = hargaSatuan * volume;
            return {
              id_pekerjaan_utama: utama.id_pekerjaan_utama,
              nama_pekerjaan: utama.nama_pekerjaan,
              uraian_pekerjaan: sub.uraian_pekerjaan,
              volume: sub.volume,
              satuan: sub.satuan,
              harga_satuan: hargaSatuan,
              total_harga: totalHarga,
            };
          })
        );
        const totalAll = allSubs.reduce(
          (sum, s) => sum + (s.total_harga || 0),
          0
        );
        // Baris hanya pekerjaan utama
        const rows = pekerjaanUtama.map((utama) => {
          const totalHargaUtama = (utama.sub_pekerjaan || []).reduce(
            (sum, sub) =>
              sum + (Number(sub.harga_satuan) * Number(sub.volume) || 0),
            0
          );
          const bobotUtama =
            totalAll > 0
              ? ((totalHargaUtama / totalAll) * 100).toFixed(2)
              : "0.00";
          const adaKurva = kurvaS.some(
            (k) =>
              Number(k.id_pekerjaan_utama) === Number(utama.id_pekerjaan_utama)
          );
          const row = {
            uraian_pekerjaan: <b>{utama.nama_pekerjaan}</b>,
            total_harga: <b>{formatRupiah(totalHargaUtama)}</b>,
            bobot: <b>{bobotUtama}</b>,
          };
          mingguList.forEach((minggu) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            row[`minggu_${minggu}`] = kurva ? `${kurva.progres_rencana}%` : "";
          });
          return row;
        });
        // Tambahkan baris total progres per minggu di paling bawah
        const totalRow = {
          uraian_pekerjaan: <b>Total</b>,
          total_harga: "",
          bobot: "",
        };
        var totPro = [];
        var labelGrap = [];
        let cumulativeTotal = 0; // Untuk menyimpan total kumulatif

        mingguList.forEach((minggu) => {
          let totalProgres = 0;
          pekerjaanUtama.forEach((utama) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            if (kurva) {
              totalProgres += Number(kurva.progres_rencana) || 0;
            }
          });

          // Akumulasi progres: minggu 2 = minggu 1 + minggu 2, minggu 3 = minggu 1 + 2 + 3
          cumulativeTotal += totalProgres;

          totalRow[`minggu_${minggu}`] = <b>{cumulativeTotal.toFixed(2)}%</b>;

          totPro.push(cumulativeTotal);
          labelGrap.push(`Minggu ${minggu}`);
        });

        const dataGrap = {
          labels: labelGrap,
          datasets: { label: "Kurva S", color: "info", data: totPro },
        };

        setDataGrap(dataGrap);
        rows.push(totalRow);
        setTableRows(rows);
      })
      .catch(() => setTableRows([]));
  };

  useEffect(() => {
    // Immediately reset state when selectedProyek changes
    setDataGrap({ labels: [], datasets: {} });

    if (!selectedProyek || !selectedProyek.value) {
      setTableRows([]);
      setTableColumns([...staticColumns]);
      return;
    }
    axios
      .get(`${API_HOHOLOK}proyek/kurvas/${selectedProyek.value}`)
      .then((res) => {
        const data = res.data || {};
        const pekerjaanUtama = data.pekerjaan_utama || [];
        const kurvaS = data.kurva_s || [];
        // Ambil semua minggu unik dari data kurvaS
        const mingguListBaru = [
          ...new Set(kurvaS.map((k) => k.minggu_ke)),
        ].sort((a, b) => a - b);
        // Kolom dinamis minggu
        const mingguColumnsBaru = mingguListBaru.map((minggu) => ({
          Header: `Minggu ${minggu}`,
          accessor: `minggu_${minggu}`,
          width: "8%",
        }));
        setTableColumns([...staticColumns, ...mingguColumnsBaru]);
        // Hitung total harga semua sub pekerjaan untuk bobot global
        let allSubs = pekerjaanUtama.flatMap((utama) =>
          (utama.sub_pekerjaan || []).map((sub) => {
            const hargaSatuan = Number(sub.harga_satuan) || 0;
            const volume = Number(sub.volume) || 0;
            const totalHarga = hargaSatuan * volume;
            return {
              id_pekerjaan_utama: utama.id_pekerjaan_utama,
              total_harga: totalHarga,
            };
          })
        );
        const totalAll = allSubs.reduce(
          (sum, s) => sum + (s.total_harga || 0),
          0
        );
        // Baris hanya pekerjaan utama
        const rows = pekerjaanUtama.map((utama) => {
          const totalHargaUtama = (utama.sub_pekerjaan || []).reduce(
            (sum, sub) =>
              sum + (Number(sub.harga_satuan) * Number(sub.volume) || 0),
            0
          );
          const bobotUtama =
            totalAll > 0
              ? ((totalHargaUtama / totalAll) * 100).toFixed(2)
              : "0.00";
          const adaKurva = kurvaS.some(
            (k) =>
              Number(k.id_pekerjaan_utama) === Number(utama.id_pekerjaan_utama)
          );
          const row = {
            uraian_pekerjaan: <b>{utama.nama_pekerjaan}</b>,
            total_harga: <b>{formatRupiah(totalHargaUtama.toString())}</b>,
            bobot: <b>{bobotUtama}</b>,
          };
          mingguListBaru.forEach((minggu) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            row[`minggu_${minggu}`] = kurva
              ? `${kurva.progres_rencana.toFixed(2)}%`
              : "";
          });
          return row;
        });
        // Tambahkan baris total progres per minggu di paling bawah
        const totalRow = {
          uraian_pekerjaan: <b>Total</b>,
          total_harga: "",
          bobot: "",
        };
        var totPro = [];
        var labelGrap = [];
        let cumulativeTotal = 0; // Untuk menyimpan total kumulatif

        mingguListBaru.forEach((minggu) => {
          let totalProgres = 0;
          pekerjaanUtama.forEach((utama) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            if (kurva) {
              totalProgres += Number(kurva.progres_rencana) || 0;
            }
          });

          // Akumulasi progres: minggu 2 = minggu 1 + minggu 2, minggu 3 = minggu 1 + 2 + 3
          cumulativeTotal += totalProgres;

          totalRow[`minggu_${minggu}`] = <b>{cumulativeTotal.toFixed(2)}%</b>;

          totPro.push(cumulativeTotal);
          labelGrap.push(`Minggu ${minggu}`);
        });

        const dataGrap = {
          labels: labelGrap,
          datasets: { label: "Kurva S", color: "info", data: totPro },
        };

        setDataGrap(dataGrap);
        rows.push(totalRow);
        setTableRows(rows);
      })
      .catch(() => {
        setTableRows([]);
        setTableColumns([...staticColumns]);
      });
  }, [selectedProyek, dataKurvaSPerUtama]);

  // useLayoutEffect for immediate state reset before render
  useLayoutEffect(() => {
    if (selectedProyek) {
      setDataGrap({ labels: [], datasets: {} });
    }
  }, [selectedProyek?.value]);

  // Handler form kurva S
  const handleKurvaSChange = (idx, e) => {
    const { name, value } = e.target;
    const newForm = [...kurvaSForm];
    newForm[idx][name] = value;
    setKurvaSForm(newForm);
  };
  const handleAddKurvaS = () => {
    let nextMinggu = 1;
    if (kurvaSForm.length > 0) {
      // Cari minggu_ke terbesar yang sudah ada
      const mingguList = kurvaSForm
        .map((item) => Number(item.minggu_ke))
        .filter((v) => !isNaN(v) && v > 0);
      if (mingguList.length > 0) {
        nextMinggu = Math.max(...mingguList) + 1;
      }
    }
    setKurvaSForm([
      ...kurvaSForm,
      { minggu_ke: nextMinggu, progres_rencana: "" },
    ]);
    // Fokus ke input minggu_ke baris terakhir (opsional, jika ingin autofokus, perlu ref)
  };
  const handleRemoveKurvaS = (idx) => {
    if (kurvaSForm.length === 1) return;
    setKurvaSForm(kurvaSForm.filter((_, i) => i !== idx));
  };
  const handleKurvaSSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProyek) {
      swal("Pilih proyek terlebih dahulu", "", "warning");
      return;
    }
    if (!selectedUtama || !selectedUtama.id_pekerjaan_utama) {
      swal("Pilih pekerjaan utama terlebih dahulu", "", "warning");
      return;
    }
    const userStorage = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;
    const id_admin = userStorage && userStorage.uid ? userStorage.uid : null;

    if (!id_admin) {
      swal("ID Admin tidak ditemukan di localStorage", "", "warning");
      return;
    }
    for (const item of kurvaSForm) {
      if (!item.minggu_ke || !item.progres_rencana) {
        swal("Semua minggu dan progres wajib diisi", "", "warning");
        return;
      }
      if (
        Number(item.progres_rencana) < 0 ||
        Number(item.progres_rencana) > 100
      ) {
        swal("Progres rencana harus antara 0-100", "", "warning");
        return;
      }
    }
    setKurvaSLoading(true);

    try {
      if (isEditKurvaS) {
        // Update (PUT)
        await axios.put(`${API_HOHOLOK}kurva-s`, {
          id_proyek: selectedProyek.value,
          id_admin: id_admin,
          id_pekerjaan_utama: selectedUtama.id_pekerjaan_utama,
          data: kurvaSForm.map((item) => ({
            minggu_ke: item.minggu_ke,
            progres_rencana: item.progres_rencana,
            id_kurva: item.id_kurva,
          })),
        });
        swal("Berhasil", "Data kurva S berhasil diupdate", "success");
      } else {
        // Input baru (POST)
        await axios.post(`${API_HOHOLOK}kurva-s`, {
          id_proyek: selectedProyek.value,
          id_admin: id_admin,
          id_pekerjaan_utama: selectedUtama.id_pekerjaan_utama,
          data: kurvaSForm.map((item) => ({
            minggu_ke: item.minggu_ke,
            progres_rencana: item.progres_rencana,
          })),
        });
        swal("Berhasil", "Data kurva S berhasil disimpan", "success");
      }
      setOpenKurvaS(false);
      setKurvaSForm([{ minggu_ke: "", progres_rencana: "" }]);
      // Panggil ulang fetchProyekKurvas agar tabel terupdate
      if (selectedProyek && selectedProyek.value) {
        fetchProyekKurvas(selectedProyek.value);
      }
    } catch (err) {
      swal(
        "Gagal",
        err?.response?.data?.message || "Terjadi kesalahan saat menyimpan data",
        "error"
      );
    }
    setKurvaSLoading(false);
  };

  const handleTahunChange = (newValue) => {
    setTahun(newValue);
  };

  const handleOpenKurvaSModal = (utama, kurvaS) => {
    // Bandingkan id_pekerjaan_utama sebagai number agar benar-benar konsisten
    const dataKurva = kurvaS.filter(
      (k) => Number(k.id_pekerjaan_utama) == Number(utama.id_pekerjaan_utama)
    );

    if (dataKurva.length > 0) {
      // Edit mode
      setKurvaSForm(
        dataKurva.map((item) => ({
          minggu_ke: item.minggu_ke,
          progres_rencana: item.progres_rencana,
          id_kurva: item.id_kurva, // simpan id untuk update
        }))
      );
      setIsEditKurvaS(true);
    } else {
      // Input baru, minggu_ke otomatis 1
      setKurvaSForm([{ minggu_ke: 1, progres_rencana: "" }]);
      setIsEditKurvaS(false);
    }
    setOpenKurvaS(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <MDBox mb={3}>
          <MDBox mb={2} display="flex" alignItems="center" gap={2}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={proyekList}
                      value={selectedProyek}
                      onChange={(event, newValue) =>
                        setSelectedProyek(newValue)
                      }
                      loading={loading}
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      renderInput={(params) => (
                        <MDInput
                          {...params}
                          label="Pilih Proyek"
                          variant="standard"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      sx={{ minWidth: 250 }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <Autocomplete
                      options={[2024, 2025, 2026, 2027, 2028, 2029]}
                      value={tahun || 2025}
                      onChange={(event, newValue) => {
                        if (typeof handleTahunChange === "function") {
                          handleTahunChange(newValue);
                        } else {
                          setTahun && setTahun(newValue);
                        }
                      }}
                      getOptionLabel={(option) => option.toString()}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tahun"
                          variant="standard"
                          fullWidth
                        />
                      )}
                      sx={{ minWidth: 120 }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </MDBox>

          {selectedProyek && (
            <MDBox mt={1} p={2} borderRadius={2} bgcolor="#f5f5f5">
              <MDTypography variant="button" fontWeight="bold">
                Proyek Terpilih:
              </MDTypography>
              <MDTypography variant="body2">
                {selectedProyek.label}
              </MDTypography>
              <MDTypography variant="caption" color="text">
                Lokasi: {selectedProyek.lokasi || "-"}
              </MDTypography>
            </MDBox>
          )}
          <Card>
            <MDBox p={3} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                Daftar Pekerjaan Proyek
              </MDTypography>
              <MDTypography variant="button" color="text">
                Tabel pekerjaan utama dan sub pekerjaan proyek terpilih.
              </MDTypography>
            </MDBox>
            <DataTable
              table={{ columns: tableColumns, rows: tableRows }}
              entriesPerPage={{ defaultValue: 100, values: [100] }}
            />
          </Card>

          <MDBox mb={2} display="flex" alignItems="center" gap={2}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <ReportsLineChart
                  key={`chart-${selectedProyek?.value}-${tahun}-${dataGrap.labels.length}`}
                  color="success"
                  title="Grafik Kurva S"
                  description={""}
                  date="updated 4 min ago"
                  chart={dataGrap}
                />
              </CardContent>
            </Card>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Kurva_S;
